import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData, imageBaseURL } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import { useFontSize } from "../../../../FontSizeContext";
import { getMenu, getAPIPath } from "../../../../utils/getDomainData";

const OTPRI_AdmissionDetails = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [categoryFilter, setCategoryFilter] = useState('All');
    const [sortBy, setSortBy] = useState('academic_year');
    const [sortOrder, setSortOrder] = useState('desc');
    let location = useLocation();
    const currentDomain = location.pathname.split("/")[1];
    const { fontSize } = useFontSize();

    useEffect(() => {
        fetchData(getAPIPath(currentDomain)?.admissionDetails, setData);
    }, [currentDomain]);

    // Filter and sort data
    useEffect(() => {
        if (data?.data) {
            let filtered = data.data;
            
            // Apply category filter
            if (categoryFilter !== 'All') {
                filtered = filtered.filter(item => item.attributes.category === categoryFilter);
            }
            
            // Apply sorting
            filtered = filtered.sort((a, b) => {
                const aValue = a.attributes[sortBy];
                const bValue = b.attributes[sortBy];
                
                if (sortOrder === 'asc') {
                    return aValue > bValue ? 1 : -1;
                } else {
                    return aValue < bValue ? 1 : -1;
                }
            });
            
            setFilteredData(filtered);
        }
    }, [data, categoryFilter, sortBy, sortOrder]);

    const admissionData = data?.data || [];
    const uniqueCategories = [...new Set(admissionData.map(item => item.attributes.category))];

    // Calculate statistics
    const totalAdmissions = filteredData.reduce((sum, item) => 
        sum + item.attributes.guys_count + item.attributes.girls_count, 0);
    const totalMale = filteredData.reduce((sum, item) => sum + item.attributes.guys_count, 0);
    const totalFemale = filteredData.reduce((sum, item) => sum + item.attributes.girls_count, 0);

    return (
        <React.Fragment>
            <Helmet>
                <title>Admission Details | Oil Technological & Pharmaceutical Research Institute | JNTU Anantapur</title>
                <meta
                    name="description"
                    content="Admission Details at JNTUA Oil Technological and Pharmaceutical Research Institute (OT&PRI) - View admission statistics, course-wise data, and academic information."
                />
                <meta
                    name="keywords"
                    content="OTPRI Admission Details, Oil Technological, Pharmaceutical Research Institute, JNTUA, Admission Statistics, Course Data"
                ></meta>
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="home"
                TopBar="enable"
                TopBarClass="topbar-area dark-primary-bg hidden-lg"
            />
            <style>
                {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .admission-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }
                    
                    .admission-section {
                        background: #fff;
                        padding: 50px 0;
                    }
                    .section-heading {
                        color: #007bff;
                        font-weight: bold;
                        margin-bottom: 30px;
                        border-bottom: 3px solid #007bff;
                        padding-bottom: 10px;
                        display: inline-block;
                    }
                    .statistics-section {
                        background: #f8f9fa;
                        padding: 40px;
                        border-radius: 15px;
                        margin-bottom: 40px;
                        border: 1px solid #dee2e6;
                    }
                    .stats-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                        gap: 25px;
                        margin-top: 20px;
                    }
                    .stat-card {
                        background: #fff;
                        padding: 25px;
                        border-radius: 12px;
                        box-shadow: 0 5px 15px rgba(0,0,0,0.1);
                        text-align: center;
                        border-top: 4px solid #007bff;
                        transition: transform 0.3s ease, box-shadow 0.3s ease;
                    }
                    .stat-card:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 8px 25px rgba(0,0,0,0.15);
                    }
                    .stat-card:nth-child(2) {
                        border-top-color: #28a745;
                    }
                    .stat-card:nth-child(3) {
                        border-top-color: #dc3545;
                    }
                    .stat-card:nth-child(4) {
                        border-top-color: #ffc107;
                    }
                    .stat-number {
                        font-size: 2.5rem;
                        font-weight: bold;
                        color: #007bff;
                        margin-bottom: 10px;
                        line-height: 1;
                    }
                    .stat-label {
                        color: #666;
                        font-weight: 600;
                        font-size: 0.95rem;
                    }
                    .controls-section {
                        background: #fff;
                        padding: 30px;
                        border-radius: 12px;
                        box-shadow: 0 3px 10px rgba(0,0,0,0.1);
                        margin-bottom: 30px;
                        border: 1px solid #e9ecef;
                    }
                    .controls-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                        gap: 20px;
                        align-items: end;
                    }
                    .control-group {
                        display: flex;
                        flex-direction: column;
                    }
                    .control-label {
                        font-weight: 600;
                        color: #333;
                        margin-bottom: 8px;
                        font-size: 0.9rem;
                    }
                    .control-select {
                        padding: 10px 15px;
                        border: 2px solid #e9ecef;
                        border-radius: 8px;
                        background: #fff;
                        font-size: 0.9rem;
                        transition: border-color 0.3s ease;
                    }
                    .control-select:focus {
                        outline: none;
                        border-color: #007bff;
                        box-shadow: 0 0 0 0.2rem rgba(0,123,255,0.25);
                    }
                    .table-container {
                        background: #fff;
                        border-radius: 12px;
                        overflow: hidden;
                        box-shadow: 0 5px 15px rgba(0,0,0,0.1);
                        border: 1px solid #e9ecef;
                    }
                    .admission-table {
                        width: 100%;
                        border-collapse: collapse;
                        margin: 0;
                    }
                    .admission-table th {
                        background: linear-gradient(135deg, #007bff, #0056b3);
                        color: white;
                        padding: 18px 15px;
                        text-align: left;
                        font-weight: 600;
                        font-size: 0.9rem;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                        border: none;
                    }
                    .admission-table td {
                        padding: 15px;
                        border-bottom: 1px solid #e9ecef;
                        font-size: 0.9rem;
                        transition: background-color 0.3s ease;
                    }
                    .admission-table tbody tr:hover {
                        background-color: #f8f9fa;
                    }
                    .admission-table tbody tr:last-child td {
                        border-bottom: none;
                    }
                    .course-name {
                        font-weight: 600;
                        color: #007bff;
                    }
                    .category-badge {
                        display: inline-block;
                        padding: 4px 12px;
                        border-radius: 20px;
                        font-size: 0.8rem;
                        font-weight: 600;
                        text-transform: uppercase;
                    }
                    .category-ug {
                        background: #e3f2fd;
                        color: #1976d2;
                    }
                    .category-pg {
                        background: #f3e5f5;
                        color: #7b1fa2;
                    }
                    .category-phd {
                        background: #fff3e0;
                        color: #f57c00;
                    }
                    .gender-stats {
                        display: flex;
                        gap: 10px;
                        align-items: center;
                    }
                    .male-count {
                        color: #007bff;
                        font-weight: 600;
                    }
                    .female-count {
                        color: #dc3545;
                        font-weight: 600;
                    }
                    .total-count {
                        background: #f8f9fa;
                        padding: 4px 8px;
                        border-radius: 6px;
                        font-weight: 600;
                        color: #333;
                    }
                    .no-data {
                        text-align: center;
                        color: #666;
                        font-style: italic;
                        padding: 60px 20px;
                        background: #f8f9fa;
                        border-radius: 12px;
                        margin: 20px 0;
                    }
                    .no-data h3 {
                        color: #333;
                        margin-bottom: 15px;
                    }
                    @media (max-width: 768px) {
                        .admission-table {
                            font-size: 0.8rem;
                        }
                        .admission-table th,
                        .admission-table td {
                            padding: 10px 8px;
                        }
                        .stats-grid {
                            grid-template-columns: repeat(2, 1fr);
                        }
                        .controls-grid {
                            grid-template-columns: 1fr;
                        }
                    }
                `}
            </style>
            <div className="pageTopOffset">
                {/* breadcrumb-area-start */}
                <SiteBreadcrumb
                    pageTitle="Admission Details"
                    pageName="Admission Details"
                    breadcrumbsClass="breadcrumb-bg"
                />
                {/* breadcrumb-area-start */}
                {getMenu(currentDomain)}
                
                <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
                    <div className="container">
                        <div className="row">
                            <div className="col pl-20 md-pl-14">
                                <div className="row">
                                    <div className="rs-inner-blog col-lg-12">
                                        {/* Page Title */}
                                        <h1 className="admission-title text-center mb-5">
                                            JNTUA-OTPRI Admission Details
                                        </h1>

                                        {/* Statistics Section */}
                                        {admissionData.length > 0 && (
                                            <div className="statistics-section">
                                                <h2 className="section-heading">Admission Statistics</h2>
                                                <div className="stats-grid">
                                                    <div className="stat-card">
                                                        <div className="stat-number">{totalAdmissions}</div>
                                                        <div className="stat-label">Total Admissions</div>
                                                    </div>
                                                    <div className="stat-card">
                                                        <div className="stat-number" style={{color: '#28a745'}}>{totalMale}</div>
                                                        <div className="stat-label">Male Students</div>
                                                    </div>
                                                    <div className="stat-card">
                                                        <div className="stat-number" style={{color: '#dc3545'}}>{totalFemale}</div>
                                                        <div className="stat-label">Female Students</div>
                                                    </div>
                                                    <div className="stat-card">
                                                        <div className="stat-number" style={{color: '#ffc107'}}>{uniqueCategories.length}</div>
                                                        <div className="stat-label">Course Categories</div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Filters and Controls */}
                                        {admissionData.length > 0 && (
                                            <div className="controls-section">
                                                <div className="controls-grid">
                                                    <div className="control-group">
                                                        <label className="control-label">Filter by Category</label>
                                                        <select 
                                                            className="control-select"
                                                            value={categoryFilter}
                                                            onChange={(e) => setCategoryFilter(e.target.value)}
                                                        >
                                                            <option value="All">All Categories</option>
                                                            {uniqueCategories.map(category => (
                                                                <option key={category} value={category}>{category}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="control-group">
                                                        <label className="control-label">Sort by</label>
                                                        <select 
                                                            className="control-select"
                                                            value={sortBy}
                                                            onChange={(e) => setSortBy(e.target.value)}
                                                        >
                                                            <option value="academic_year">Academic Year</option>
                                                            <option value="name">Course Name</option>
                                                            <option value="yesr_etd">Year Established</option>
                                                            <option value="guys_count">Male Count</option>
                                                            <option value="girls_count">Female Count</option>
                                                        </select>
                                                    </div>
                                                    <div className="control-group">
                                                        <label className="control-label">Sort Order</label>
                                                        <select 
                                                            className="control-select"
                                                            value={sortOrder}
                                                            onChange={(e) => setSortOrder(e.target.value)}
                                                        >
                                                            <option value="desc">Descending</option>
                                                            <option value="asc">Ascending</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Admission Table */}
                                        {filteredData.length > 0 ? (
                                            <div className="admission-section">
                                                <h2 className="section-heading">Course-wise Admission Data</h2>
                                                <div className="table-container">
                                                    <table className="admission-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Course Name</th>
                                                                <th>Category</th>
                                                                <th>Academic Year</th>
                                                                <th>Year Established</th>
                                                                <th>Male</th>
                                                                <th>Female</th>
                                                                <th>Total</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {filteredData.map((item, index) => (
                                                                <tr key={item.id || index}>
                                                                    <td className="course-name">{item.attributes.name}</td>
                                                                    <td>
                                                                        <span className={`category-badge category-${item.attributes.category.toLowerCase()}`}>
                                                                            {item.attributes.category}
                                                                        </span>
                                                                    </td>
                                                                    <td>{item.attributes.academic_year}</td>
                                                                    <td>{item.attributes.yesr_etd}</td>
                                                                    <td className="male-count">{item.attributes.guys_count}</td>
                                                                    <td className="female-count">{item.attributes.girls_count}</td>
                                                                    <td>
                                                                        <span className="total-count">
                                                                            {item.attributes.guys_count + item.attributes.girls_count}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="no-data">
                                                <h3>Admission Details</h3>
                                                <p>Admission details will be updated soon. Please check back later for comprehensive admission statistics and course-wise data.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Accreditation />

            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />

            {/* scrolltop-start */}
            <ScrollToTop scrollClassName="scrollup orange-color" />
            {/* scrolltop-end */}

            <SearchModal />
        </React.Fragment>
    );
};

export default OTPRI_AdmissionDetails;